"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import Rating from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating";
import styles from "../../ProductAccordion.module.scss";
import Script from "next/script";

export const PRODUCT_REVIEWS_ACCORDION_INSTANCE_NAME = "product-reviews";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "jl-reviews": {
        "data-testid"?: string;
        productId: string;
        apiKey: string;
        clientId: string;
        modalRootId: string;
        displayTitle: boolean;
        accordion: boolean;
        reviewSummary?: {
          averageRating: number;
          numberOfReviews: number;
        };
        productUrl?: string;
        media?: string;
        experiments?: string;
      };
    }
  }
}

type Props = {
  productId: string;
  reviewsApiKey: string;
  reviewsScriptUrl: string;
  reviewSummary?: { averageRating: number; numberOfReviews: number } | null;
  productUrl?: string;
  open?: boolean;
  experiencesRawString: string;
};

export function ProductReviewsAccordionUI({
  productId,
  reviewsApiKey,
  reviewsScriptUrl,
  reviewSummary,
  productUrl,
  open,
  experiencesRawString,
}: Props) {
  let productReviewLabel: string | JSX.Element = "Reviews";

  if (reviewSummary?.averageRating) {
    const rating = {
      averageRating: reviewSummary.averageRating,
      reviews: reviewSummary.numberOfReviews,
    };
    productReviewLabel = (
      <span
        data-testid={"product-reviews-label"}
        aria-label={`Reviews | ${reviewSummary.averageRating} out of 5 stars`}
      >
        Reviews
        <span
          className={styles.productReviewSummary}
          data-testid="product-review-summary"
        >
          |
          <Rating size="large" suffixType="ratingAndMax" rating={rating} />
        </span>
      </span>
    );
  }

  return (
    <Accordion
      id="ratings-reviews-section"
      className={styles.ratingsReviewsSection}
      data-testid="accordion:reviews"
      label={productReviewLabel}
      animated={true}
      instanceName={PRODUCT_REVIEWS_ACCORDION_INSTANCE_NAME}
      responsive
      open={open}
    >
      <div>
        <jl-reviews
          data-testid={"product-reviews"}
          productId={productId}
          apiKey={reviewsApiKey}
          clientId={"web-pdp-scaffold-ui"}
          modalRootId={"page-root"}
          displayTitle={false}
          accordion={true}
          productUrl={productUrl}
          experiments={experiencesRawString}
        />
      </div>
      <Script
        data-testid={"product-reviews-script"}
        defer
        type={"text/javascript"}
        src={reviewsScriptUrl}
      />
    </Accordion>
  );
}
